module.exports = __webpack_public_path__ + "static/level-7-logo.9d3f949b.png";